<template>
                <v-container fluid grid-list-md>

    <v-dialog fullscreen v-if="overlayActive" v-model="overlayActive">
        <v-img max-height="100vh" contain :src="images[currentImage].src" @click.self="closeOverlay" :alt="images[currentImage].alt" >
       <v-layout  column v-touch="{
        right: () => prevImage(),
        left: () => nextImage()
        }">
        <v-card>
                        <v-card-title style="background: rgba(0,0,0,0.5)" class='headline'>
         <v-icon left @click="prevImage">chevron_left</v-icon>
         {{ currentImage+1 }}/{{ images.length }} {{ name }} {{ images[currentImage].alt }}
         <v-spacer></v-spacer>
         <v-icon left  @click="saveImage(currentImage)">save_alt</v-icon>
         <v-icon  @click="nextImage">chevron_right</v-icon>
         <v-icon right @click="closeOverlay">close</v-icon>
            
        </v-card-title>
        
        </v-card>
        </v-layout>
        </v-img>
    </v-dialog>

         <v-layout row wrap>
                <v-flex xs6 md4 lg3 xl2  v-for="(image, index) in images" :key="index">
                    
                    
            <v-card @click="clickImage(index)">
        <v-img style="z-index: 1; background-color: white;" height="300" @error="hideme(index)" :src="image.thumbnail" :alt="image.alt"></v-img>
    </v-card> 
    </v-flex>
    </v-layout>
        <p v-if="caption && images[currentImage].caption">{{ images[currentImage].caption }}</p>

  </v-container>
</template>

<script>
    export default {
        props: {
            resetstyles: {
                default: false,
                type: Boolean,
            },
            title: {
                type: String,
            },
            images: {
                type: Array,
            },
            loop: {
                default: true,
                type: Boolean,
            },
            nav: {
                default: true,
                type: Boolean,
            },
            name: {
                type: String
            },
            caption: {
                default: false,
                type: Boolean,
            },
        },
        data() {
            return {
                currentImage: null,
                overlayActive: false,
            };
        },
        mounted() {
            const self = this;
            window.addEventListener('keydown', (e) => {
                self.handleGlobalKeyDown(e);
            });
        },
        methods: {
            saveImage(i) {
                window.open(this.images[i].download, "_new");
            },
            clickImage(index) {
                this.currentImage = index;
                this.overlayActive = true;
            },
            nextImage() {
                if (this.currentImage === (this.images.length - 1)) {
                    if (this.loop) {
                        this.currentImage = 0;
                    }
                }
                else {
                    this.currentImage += 1;
                }
            },
            prevImage() {
                if (this.currentImage === 0) {
                    if (this.loop) {
                        this.currentImage = (this.images.length - 1);
                    }
                }
                else {
                    this.currentImage -= 1;
                }
            },
                        hideme: function(i) {
                var tmp = [];
                for (var key in this.images) {
                    if (key != i) {
                        tmp.push(this.images[key])
                    }
                }
                this.$parent.images = tmp;

            },

            closeOverlay() {
                this.overlayActive = false;
            },
            handleGlobalKeyDown(e) {
                switch (e.keyCode) {
                    case 37:
                        this.prevImage();
                        break;
                    case 39:
                        this.nextImage();
                        break;
                    case 27:
                        this.closeOverlay();
                        break;
                    default:
                        break;
                }
            },
        },
    };
</script>

<style scoped>
    .vue-lightbox ul {
        list-style: none;
        margin: 0 auto;
        padding: 0;
        display: block;
        max-width: 780px;
        text-align: center;
    }

    .vue-lightbox li {
        display: inline-block;
        padding: 5px;
        background: ghostwhite;
        margin: 10px;
    }

    .vue-lightbox img {
        display: block;
        width: 200px;
    }


    .lightbox-overlay {
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        left: 0;
        background: rgba(0, 0, 0, 0.9);
        text-align: center;
        padding: 20px;
        box-sizing: border-box;
    }

    .lightbox-overlay .holder {
        margin: 0 auto;
        position: relative;
        max-height: 100vh;
    }

    .lightbox-overlay .holder img {
/*        width: 100%;*/
        max-width: 100%;
        cursor: pointer;
        box-sizing: border-box;
        display: block;
/*        max-height: 100%; */
         max-height: 100vh;
    }

    .lightbox-overlay p {
        color: #ffffff;
        margin: 0;
        background-color: rgba(0, 0, 0, 0.4);
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        box-sizing: border-box;
        padding: 10px;
    }

    .lightbox-overlay .nav {
        max-width: 600px;
        margin: 0 auto;
        font-size: 14px;
    }

    .lightbox-overlay .nav a {
        color: white;
        opacity: 0.3;
        -webkit-user-select: none;
        cursor: pointer;
    }

    .lightbox-overlay .nav a:hover {
        opacity: 1;
    }

    .lightbox-overlay .nav .next,
    .prev {
        position: absolute;
        top: 0;
        bottom: 0;
        padding: 10px;
        width: 50%;
        box-sizing: border-box;
        font-size: 40px;
    }

    .lightbox-overlay .nav span {
        top: 50%;
        transform: translateY(50%);
        position: relative;
    }

    .lightbox-overlay .nav .next {
        right: 0;
        text-align: right;
    }

    .lightbox-overlay .nav .prev {
        left: 0;
        text-align: left;
    }

    .lightbox-overlay .nav .close {
        right: 10px;
        top: 0;
        font-size: 30px;
        opacity: 0.6;
        z-index: 1000000;
        position: absolute;
        text-align: left;
        box-sizing: border-box;
    }

    .lightbox-overlay .nav .close:hover {
        opacity: 1;
    }
</style>
